import { gql } from '@apollo/client';

export const CANCEL_TOOL_BOOKING = gql`
  mutation CancelToolBooking($id: ID!, $message: String) {
    cancelToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
        tool {
          id
          name
        }
      }
      errors
    }
  }
`;

export const CANCEL_TOOL_BOOKING_DIRECT = gql`
  mutation CancelToolBookingDirect($id: ID!, $message: String) {
    cancelToolBooking(id: $id, message: $message) {
      toolBooking {
        id
        status
        fromDate
        toDate
        tool {
          id
          name
        }
      }
      errors
    }
  }
`;

export const CANCEL_BORROW_TOOL_BOOKING = gql`
  mutation CancelBorrowToolBooking($id: ID!, $message: String) {
    cancelBorrowToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
      }
      errors
    }
  }
`;

export const CANCEL_BORROW_TOOL_BOOKING_DIRECT = gql`
  mutation CancelBorrowToolBookingDirect($id: ID!, $message: String) {
    cancelBorrowToolBooking(id: $id, message: $message) {
      toolBooking {
        id
        status
      }
      errors
    }
  }
`;

export const PICK_UP_TOOL_BOOKING = gql`
  mutation PickUpToolBooking($id: ID!) {
    pickUpToolBooking: toolPickedUp(input: { id: $id }) {
      toolBooking {
        id
        status
      }
      errors
    }
  }
`;

export const PICK_UP_TOOL_BOOKING_DIRECT = gql`
  mutation PickUpToolBookingDirect($id: ID!) {
    pickUpToolBooking: toolPickedUp(input: { id: $id }) {
      toolBooking {
        id
        status
      }
      errors
    }
  }
`;

